import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MedicalRecordProblemModel
} from "../../../../../../../modules/medical/medical-record/problem/api/model/medicalRecordProblem.model";
import {
  CustomDateFieldModule
} from "../../../../../../../components/common/date/custom-date/custom-date-field/custom-date-field.module";
import {
  DateSummaryFieldModule
} from "../../../../../../../modules/core/component/date/date-summary-field/date-summary-field.module";
import {
  LovValueSummaryFieldModule
} from "../../../../../../../modules/common/lov/lov-value/api/component/lov-value-summary-field/lov-value-summary-field.module";
import {RatingModule} from "../../../../../../../modules/core/component/rating/rating.module";
import {SummaryFieldModule} from "../../../../../../../modules/core/component/summary-field/summary-field.module";
import {
  CommentSummaryFieldModule
} from "../../../../../../../modules/core/component/comment/comment-summary-field/comment-summary-field.component";
import {ItemModule} from "../../../../../../../modules/core/component/item/item.module";
import {ButtonComponent} from "../../../../core/components/api/button/button.component";
import {
  MedicalProblemSaveDialogInput, MedicalProblemSaveDialogResult,
  MedicalRecordProblemCreateUpdateComponent
} from "../../../../../../../modules/medical/medical-record/problem/api/component/medical-record-problem-create-update/medical-record-problem-create-update.component";
import {DialogController} from "../../../../../../../modules/common/dialog/dialogController";
import {
  MedicalRecordProblemCreateUpdateModule
} from "../../../../../../../modules/medical/medical-record/problem/api/component/medical-record-problem-create-update/medical-record-problem-create-update.module";
import {
  MedicalProblemDeleteService
} from "../../../../../../../modules/medical/medical-record/problem/impl/service/medicalProblemDelete.service";
import {IconsModule} from "../../../../../../../../icons.module";
import {SummaryModule} from "../../../../../../../modules/core/component/summary/summary.module";
import {DateLabelModule} from "../../../../../../../modules/core/component/date/date-label/date-label.module";

@Component({
  selector: 'app-luna-consultation-problem-item',
  standalone: true,
  imports: [CommonModule, CustomDateFieldModule, DateSummaryFieldModule, LovValueSummaryFieldModule, RatingModule, SummaryFieldModule, CommentSummaryFieldModule, ItemModule, ButtonComponent, MedicalRecordProblemCreateUpdateModule, IconsModule, SummaryModule, DateLabelModule],
  templateUrl: './consultation-problem-item.component.html',
  providers: [
      MedicalProblemDeleteService
  ]
})
export class ConsultationProblemItemComponent {

  @Input() problem: MedicalRecordProblemModel;
  @Input() hideButtons = false;
  @Input() titleDisplay: 'title' | 'type' = 'type';

  constructor(private dialogController: DialogController,
              public deleteService: MedicalProblemDeleteService) {

  }

  edit() {
    const input: MedicalProblemSaveDialogInput = {
      id: this.problem.id
    };
    const dialog = this.dialogController.open(MedicalRecordProblemCreateUpdateComponent,
        input, {title: 'Modifier le problème / l\'antécédent'});
    dialog.afterClosed().toPromise().then((result: MedicalProblemSaveDialogResult) => {
      if (result) {
        this.problem = result.entity;
      }
    });
  }
}
